import React, { useEffect, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import queryString from "query-string";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";

import { Color } from "../../../components/Form/Button";
import TaskService from "Services/task.service";
import { AppPageCardInform } from "Components/AppPageCardInform";

type RejectInvitePayload = {
  token: string;
};

type DecodedProps = {
  agentId: number;
  taskId: number;
};

export const RejectedTaskInvite = () => {
  const history = useHistory();
  const { t: translate } = useTranslation();

  // eslint-disable-next-line no-restricted-globals
  const parsed: { token?: string } = queryString.parse(location.search);

  const [token, setToken] = useState<string>("");

  const {
    mutate: rejectInvite,
    isLoading: isLoadingInviteAgent,
    isError,
  } = useMutation(["task.invite.agent"], (payload: RejectInvitePayload) =>
    TaskService.acceptOrRejectAgentInvite(payload.token, "decline")
  );

  const handleCloseWindow = () => {
    window.close();
  };

  const getContentProps = () => {
   if (isLoadingInviteAgent) return {
      title: translate("loading"),
    };

    if (isError) {
      return {
        title: translate("invalidLink"),
        content: translate("theInviteLinkIsBroken"),
        actionText: translate("closeWindow"),
        onActionClick: handleCloseWindow,
        actionColor: Color.SECONDARY_DARK
      };
    }

    return {
      icon: <SentimentVeryDissatisfiedIcon sx={{ color: "#E6EEF6", fontSize: 72 }} />,
      title: "You haven't accepted the task.",
      content: "You can safely close this window now. If you need any further assistance, feel free to reach out. Have a great day!",
      actionText: translate("closeWindow"),
      onActionClick: handleCloseWindow,
      actionColor: Color.SECONDARY_DARK
    };
  };

  useEffect(() => {
    if (parsed?.token) {
      setToken(parsed.token);
    } else {
      history.replace("/");
    }
  }, [parsed]);

  useEffect(() => {
    if (token) {

      rejectInvite({
        token,
      });
    }
  }, [token]);

  return <AppPageCardInform {...getContentProps()} />;
};